import { render, staticRenderFns } from "./MypageFavoriteTeamInitSelectPane.vue?vue&type=template&id=5cc3a9a1&scoped=true"
import script from "./MypageFavoriteTeamInitSelectPane.vue?vue&type=script&lang=ts"
export * from "./MypageFavoriteTeamInitSelectPane.vue?vue&type=script&lang=ts"
import style0 from "./MypageFavoriteTeamInitSelectPane.vue?vue&type=style&index=0&id=5cc3a9a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc3a9a1",
  null
  
)

export default component.exports